import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { SliderService } from 'src/generated_client';

@Component({
  selector: 'app-add-slider',
  templateUrl: './add-slider.component.html',
  styleUrls: ['./add-slider.component.css']
})
export class AddSliderComponent implements OnInit {

  addSliderForm: FormGroup = this.fb.group({

    dsTitle: ['', Validators.required],
    dsImg: ['', Validators.required],
    nmSortNo: ['', Validators.required]
  })

  constructor(
    private fb: FormBuilder,
    private sliderService: SliderService,
    private snackBar: SnackBarService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  saveChanges(form: any) {

    this.sliderService.apiSliderPostPostForm(form.dsTitle, undefined, form.nmSortNo, form.dsImg._files[0]).subscribe(() => {

      this.router.navigate(['start-slider']);
      this.snackBar.openSnackBar('El slider se agregó correctamente','Aceptar')
    },
      err => {
        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse', 'Aceptar')
      }
    )
  }
}
